import { publicAxiosInstance } from '../../utils/axios';
import { Event } from '../types/event';

export const eventsService = {
  async getEvents(location?: string): Promise<Event[]> {
    const params = location ? { location } : undefined;
    const response = await publicAxiosInstance.get('/api/v1/events', { params });
    return response.data;
  }
};
